(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-form.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-form.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.ticketsOrderHome.utils.logger;
const useOrderHomeContext = svs.ticketsOrderHome.context.useOrderHomeContext;
const searchReceiversAsync = svs.ticketsOrderHome.services.searchReceiversAsync;
const Loader = svs.ticketsOrderHome.components.Loader;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Form = svs.ui.reactForm.Form;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _React = React,
  Fragment = _React.Fragment,
  useState = _React.useState;
const characterValidator = svs.ticketsOrderHome.utils.characterValidator;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils.constants.orderHomeReceiver.errors,
  NO_SEARCH_RESULTS = _svs$ticketsOrderHome.NO_SEARCH_RESULTS,
  INPUT_VALIDATION_FAILED = _svs$ticketsOrderHome.INPUT_VALIDATION_FAILED,
  TOO_MANY_SEARCH_RESULTS = _svs$ticketsOrderHome.TOO_MANY_SEARCH_RESULTS;
const SearchForm = () => {
  var _receiver$search, _receiver$search$fnam, _receiver$search2, _receiver$search$lnam, _receiver$search3, _receiver$search$stre, _receiver$search4, _receiver$search$city, _receiver$search5;
  const _useOrderHomeContext = useOrderHomeContext(),
    receiver = _useOrderHomeContext.state.receiver,
    setReceiver = _useOrderHomeContext.setReceiver,
    setReceiverSearchResult = _useOrderHomeContext.setReceiverSearchResult;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    searchError = _useState4[0],
    setSearchError = _useState4[1];
  const _ref = (_receiver$search = receiver.search) !== null && _receiver$search !== void 0 ? _receiver$search : {},
    fname = _ref.fname,
    lname = _ref.lname,
    street = _ref.street,
    city = _ref.city;
  const validateFn = value => {
    if (!characterValidator(value)) {
      return {
        isValid: false,
        errorMessage: 'Texten innehåller otillåtna tecken.'
      };
    }
    return {
      isValid: true
    };
  };
  const handleChangeSearch = _ref2 => {
    let _ref2$target = _ref2.target,
      name = _ref2$target.name,
      value = _ref2$target.value;
    setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
      search: _objectSpread(_objectSpread({}, receiver.search), {}, {
        [name]: value
      })
    }));
  };
  const handleSubmitSearch = async (e, formData) => {
    var _receiver$results, _receiver$results$len, _receiver$results2;
    e.preventDefault();
    const invalidInputs = Object.entries(formData).filter(_ref3 => {
      let _ref4 = _slicedToArray(_ref3, 2),
        isValid = _ref4[1].isValid;
      return !isValid;
    }).map(_ref5 => {
      let _ref6 = _slicedToArray(_ref5, 1),
        name = _ref6[0];
      return name;
    });
    if (invalidInputs.length > 0) {
      logger.info('Failed validation of inputs when searching for receiver', invalidInputs);
      return;
    }
    setSearchError(null);
    setLoading(true);
    const searchCacheKey = "".concat(fname, ",").concat(lname, ",").concat(street, ",").concat(city).toLowerCase();
    const searchCacheValue = (_receiver$results = receiver.results) === null || _receiver$results === void 0 ? void 0 : _receiver$results[searchCacheKey];
    if (searchCacheValue !== null && searchCacheValue !== void 0 && searchCacheValue.result) {
      setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
        result: searchCacheValue.result
      }));
      return;
    }
    if (searchCacheValue !== null && searchCacheValue !== void 0 && searchCacheValue.error) {
      setLoading(false);
      setSearchError(searchCacheValue.error);
      return;
    }
    logger.info("Searching for receiver with ".concat((_receiver$results$len = (_receiver$results2 = receiver.results) === null || _receiver$results2 === void 0 ? void 0 : _receiver$results2.length) !== null && _receiver$results$len !== void 0 ? _receiver$results$len : 0, " queries in cache"));
    const _ref7 = (await searchReceiversAsync({
        firstName: fname,
        lastName: lname,
        street,
        city,
        receiver
      })) || {},
      result = _ref7.result,
      error = _ref7.error;
    if (error) {
      setLoading(false);
      switch (error.code) {
        case NO_SEARCH_RESULTS.code:
        case TOO_MANY_SEARCH_RESULTS.code:
        case INPUT_VALIDATION_FAILED.code:
          setReceiverSearchResult(searchCacheKey, {
            error: error.message
          });
          setSearchError(error.message);
          break;
        default:
          setSearchError(error.message);
      }
      return;
    }
    if (result && result.length > 0) {
      var _receiver$results$len2, _receiver$results3;
      logger.info("Search call ".concat(((_receiver$results$len2 = (_receiver$results3 = receiver.results) === null || _receiver$results3 === void 0 ? void 0 : _receiver$results3.length) !== null && _receiver$results$len2 !== void 0 ? _receiver$results$len2 : 0) + 1, " returned ").concat(result.length, " results"));
      setReceiverSearchResult(searchCacheKey, {
        result
      });
    }
  };
  return React.createElement(Fragment, null, loading && React.createElement(Loader, null), searchError && React.createElement("div", null, React.createElement("h4", {
    className: "h4 fw-500 padding-bottom-2 border-bottom"
  }, "S\xF6kresultat"), React.createElement("div", {
    className: "border-bottom padding-bottom-2 margin-bottom-3 u-flex"
  }, React.createElement(Icon, {
    className: "margin-right-1 search-error-icon",
    color: "fc-red",
    icon: "exclamation-sign",
    size: "300"
  }), React.createElement("span", null, searchError))), React.createElement("h4", {
    className: "h4 fw-500 margin-bottom-half"
  }, "S\xF6k efter mottagare"), React.createElement(Form, {
    onSubmit: handleSubmitSearch
  }, React.createElement(TextInput, {
    autoComplete: "off",
    isLessSpace: true,
    isRequired: true,
    label: "F\xF6rnamn*",
    min: 2,
    name: "fname",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$fnam = (_receiver$search2 = receiver.search) === null || _receiver$search2 === void 0 ? void 0 : _receiver$search2.fname) !== null && _receiver$search$fnam !== void 0 ? _receiver$search$fnam : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: true,
    label: "Efternamn*",
    min: 2,
    name: "lname",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$lnam = (_receiver$search3 = receiver.search) === null || _receiver$search3 === void 0 ? void 0 : _receiver$search3.lname) !== null && _receiver$search$lnam !== void 0 ? _receiver$search$lnam : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: false,
    label: "Gata",
    name: "street",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$stre = (_receiver$search4 = receiver.search) === null || _receiver$search4 === void 0 ? void 0 : _receiver$search4.street) !== null && _receiver$search$stre !== void 0 ? _receiver$search$stre : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: true,
    label: "Postort*",
    name: "city",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$city = (_receiver$search5 = receiver.search) === null || _receiver$search5 === void 0 ? void 0 : _receiver$search5.city) !== null && _receiver$search$city !== void 0 ? _receiver$search$city : ''
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    iconPosition: "center",
    inverted: true,
    type: "submit"
  }, React.createElement(Icon, {
    icon: "search"
  }), "S\xF6k")));
};
setGlobal('svs.ticketsOrderHome.orderHome.receiver.components.SearchForm', SearchForm);

 })(window);